export function deleteTurn(turn) {
    let { deleteTurnRequest, deleteTurnError, deleteTurnResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'delete_turn',
        this.createBundle('delete_turn', { turn }, this.POST, deleteTurnRequest, deleteTurnResult, deleteTurnError)
    )
}
